@if(loaderService.loading() || loaderService.pendingRequests() !=0 ){
<div class="progress-bar-container">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
}